export default __webpack_public_path__ + "static/media/48.cc0375fc.jpg";